import * as React from 'react';
import { ImageFromBlob } from './ImageFromBlob';
import { Col } from '../bootstrap-components/BootstrapComponents';

export interface SectionImageProps {
  blobId?: string;
}

export function SectionImage(props: SectionImageProps) {
  let classes = 'section-image'; 

  return (
    <Col md={12} className={classes}>
      <ImageFromBlob id={props.blobId}/>
    </Col>
  );
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/layout/SectionImage.tsx